export default __webpack_public_path__ + "static/generator_symbol_b.03a97fcea2e429465d193602803553af.png";